import React from 'react';

import './SectionHeader.css';

interface SectionHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`section-header ${className}`}>
      <div className="section-header__badge"></div>
      {children}
    </div>
  );
};

export default SectionHeader;
